/**
 * Le varianti che hanno i problemi del giorno.
 *
 * La lista viveva scritta a mano in piu' punti (l'array `OTHER_PUZZLE_VARIANTS`
 * della card del bento, il selettore dell'anteprima di sviluppo): qui sta una
 * volta sola, nell'ordine in cui va mostrata.
 *
 * L'ordine e' rimasto quello di quando English e Brazilian erano le due varianti
 * col pool vuoto. Oggi vale solo per l'English (il suo unico sorgente e' un
 * segnaposto): la Brazilian ha 73 problemi da giornaliero e la sua card non mostra
 * piu' lo stato "nessun problema". Sta in coda per inerzia, non per quel motivo.
 *
 * Frysk! sta subito dopo la frisone, della cui famiglia fa parte. Era previsto di
 * ammetterla solo con un pool da 100 problemi, perche' con pochi la rotazione del
 * giorno ripropone sempre gli stessi: quella soglia non e' mai stata raggiunta (il
 * pool si e' fermato a 67, e i problemi da giornaliero sono 12). L'avvertenza resta
 * valida — il giro si chiude in 12 giorni — e la cura e' raccogliere piu' problemi
 * Frysk! da 3+ mosse, non allargare il filtro del tag.
 */
export const PUZZLE_VARIANTS = [
  'international',
  'italian',
  'frisian',
  'frysk',
  'russian',
  'english',
  'brazilian',
] as const;

export type PuzzleVariant = (typeof PUZZLE_VARIANTS)[number];

/** True se la variante ha i problemi (accetta sia 'ITALIAN' sia 'italian'). */
export function isPuzzleVariant(variant: string | undefined | null): boolean {
  if (!variant) return false;
  return (PUZZLE_VARIANTS as readonly string[]).includes(String(variant).toLowerCase());
}

/**
 * L'ordine di [PUZZLE_VARIANTS] con la variante preferita dell'utente in testa.
 *
 * Una preferita che non ha problemi (Turca, per dire) non sposta niente: si
 * torna all'ordine normale invece di mettere in cima una card vuota.
 */
export function orderedPuzzleVariants(preferred?: string | null): string[] {
  const rest = PUZZLE_VARIANTS as readonly string[];
  if (!isPuzzleVariant(preferred)) return [...rest];
  const first = String(preferred).toLowerCase();
  return [first, ...rest.filter((v) => v !== first)];
}
